module.exports = __webpack_public_path__ + "img/brodcast-samsung-mobile.d90020e6.jpg";